import { render } from "./base-notification-from-store.vue?vue&type=template&id=3876332a&ts=true"
import script from "./base-notification-from-store.vue?vue&type=script&lang=ts"
export * from "./base-notification-from-store.vue?vue&type=script&lang=ts"

import "./base-notification-from-store.vue?vue&type=style&index=0&id=3876332a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__